import { type PaginationProps } from '@packages/shared';
import { defineMessages, useIntl } from 'react-intl';

type PaginationItemType = PaginationProps['getItemAriaLabel'];

const messages = defineMessages({
  currentPagePagination: {
    id: 'pagination.page.current',
    defaultMessage: 'Seite {page}',
  },
  otherPagePagination: {
    id: 'pagination.other.page',
    defaultMessage: 'Zur Seite {page}',
  },
  goToFirstPagePagination: {
    id: 'pagination.first.page',
    defaultMessage: 'Zur ersten Seite',
  },
  goToLastPagePagination: {
    id: 'pagination.last.page',
    defaultMessage: 'Zur letzten Seite',
  },
  previousPagePagination: {
    id: 'pagination.previous.page',
    defaultMessage: 'Zur vorherigen Seite',
  },
  nextPagePagination: {
    id: 'pagination.next.page',
    defaultMessage: 'Zur nächsten Seite',
  },
});
export const usePaginationAriaLabel = () => {
  const { formatMessage } = useIntl();
  const getPaginationAriaLabel: PaginationItemType = (type, page, selected) => {
    switch (type) {
      case 'page':
        return selected
          ? formatMessage(messages.currentPagePagination, { page })
          : formatMessage(messages.otherPagePagination, { page });
      case 'first':
        return formatMessage(messages.goToFirstPagePagination);
      case 'last':
        return formatMessage(messages.goToLastPagePagination);
      case 'next':
        return formatMessage(messages.nextPagePagination);
      case 'previous':
        return formatMessage(messages.previousPagePagination);
      case 'start-ellipsis':
        return '';
      case 'end-ellipsis':
        return '';
      default:
        return '';
    }
  };
  return { getPaginationAriaLabel };
};
